import { Period } from '@heidi/commerce/contracts';
import { Badge } from '@heidi/design-system/badge';
import {
  SegmentedControlList,
  SegmentedControlTrigger,
} from '@heidi/design-system/segmented-control';

import { useTranslations } from '@heidi/runtime/i18n';

export const PeriodTabsList = () => {
  const { t } = useTranslations();
  return (
    <SegmentedControlList className="self-center">
      <SegmentedControlTrigger value={Period.ONE_YEAR} className="gap-x-1">
        {t('endTrialModal.tabs.yearly')}
        <Badge color="green" size="xs">
          {t('endTrialModal.tabs.savePercent')}
        </Badge>
      </SegmentedControlTrigger>
      <SegmentedControlTrigger value={Period.ONE_MONTH}>
        {t('endTrialModal.tabs.monthly')}
      </SegmentedControlTrigger>
    </SegmentedControlList>
  );
};
